import { NotificationStore } from './notification'
import { CommonStore } from './common'

class rootStore {
  static instance: rootStore
  commonStore: CommonStore
  notificationStore: NotificationStore

  constructor() {
    this.commonStore = new CommonStore(this)
    this.notificationStore = new NotificationStore(this)
  }
}
export default rootStore
